import type { WheelEvent } from "react";

/**
 * Lets a scrollable box inside a modal actually scroll.
 *
 * A Dialog — which is what a Sheet is — locks background scrolling through
 * react-remove-scroll, which listens for `wheel` on `document` and calls
 * `preventDefault()` on anything whose target sits outside its lock. Popover
 * and dropdown content is portalled to `document.body`, so it is outside that
 * lock and its own `overflow-y-auto` never gets a chance to run.
 *
 * The listener is on `document` and does not capture, so stopping the event at
 * the scrollable element keeps it from ever reaching the lock. Put this on the
 * element that scrolls, not on the popover around it.
 */
export const stopWheelPropagation = (event: WheelEvent) => {
  event.stopPropagation();
};
